(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lakras-product-trust-slider"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeTrustSlider = (slider) => {
      if (slider.dataset.lakrasInitialized === 'true') return;
      slider.dataset.lakrasInitialized = 'true';

      const track = slider.querySelector('[data-lakras-trust-track]');
      const slides = Array.from(slider.querySelectorAll('[data-lakras-trust-slide]'));
      const dots = Array.from(slider.querySelectorAll('[data-lakras-trust-dot]'));
      const toggle = slider.querySelector('[data-lakras-trust-toggle]');
      const toggleLabel = slider.querySelector('[data-lakras-trust-toggle-label]');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const pauseLabel = toggle.dataset.pauseLabel;
      const playLabel = toggle.dataset.playLabel;
      let currentIndex = 0;
      let timer;
      let manuallyPaused = reducedMotion.matches;
      let scrollFrame;

      const updateControls = () => {
        dots.forEach((dot, index) => {
          const active = index === currentIndex;
          dot.classList.toggle('is-active', active);
          if (active) {
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.removeAttribute('aria-current');
          }
        });
      };

      const goToSlide = (index, behavior = 'smooth') => {
        currentIndex = (index + slides.length) % slides.length;
        track.scrollTo({
          left: slides[currentIndex].offsetLeft,
          behavior: reducedMotion.matches ? 'auto' : behavior
        });
        updateControls();
      };

      const stop = () => {
        window.clearInterval(timer);
      };

      const start = () => {
        stop();
        if (manuallyPaused || reducedMotion.matches) return;
        timer = window.setInterval(() => goToSlide(currentIndex + 1), 4200);
      };

      dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          goToSlide(Number(dot.dataset.slideIndex));
          start();
        });
      });

      toggle.addEventListener('click', () => {
        manuallyPaused = !manuallyPaused;
        toggle.setAttribute('aria-pressed', String(manuallyPaused));
        toggleLabel.textContent = manuallyPaused ? playLabel : pauseLabel;
        if (manuallyPaused) stop();
        else start();
      });

      track.addEventListener('scroll', () => {
        window.cancelAnimationFrame(scrollFrame);
        scrollFrame = window.requestAnimationFrame(() => {
          const nearestIndex = slides.reduce((nearest, slide, index) => {
            const currentDistance = Math.abs(slide.offsetLeft - track.scrollLeft);
            const nearestDistance = Math.abs(slides[nearest].offsetLeft - track.scrollLeft);
            return currentDistance < nearestDistance ? index : nearest;
          }, 0);
          currentIndex = nearestIndex;
          updateControls();
        });
      }, { passive: true });

      slider.addEventListener('mouseenter', stop);
      slider.addEventListener('mouseleave', start);
      slider.addEventListener('focusin', stop);
      slider.addEventListener('focusout', (event) => {
        if (!slider.contains(event.relatedTarget)) start();
      });
      slider.addEventListener('pointerdown', stop, { passive: true });
      slider.addEventListener('pointerup', start, { passive: true });
      reducedMotion.addEventListener('change', start);

      updateControls();
      start();
    };

    const initializeAllTrustSliders = () => {
      document.querySelectorAll('[data-lakras-trust-slider]').forEach(initializeTrustSlider);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeAllTrustSliders);
    } else {
      initializeAllTrustSliders();
    }

    document.addEventListener('shopify:section:load', initializeAllTrustSliders);
  })();
  } catch(e) { console.error(e); }
})();

})();
